module.exports = __webpack_public_path__ + "img/759.6cdae711.jpg";